import $axios from '~/plugins/axios';

import { Api, CampaignVisual, GetCampaignVisualParams } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetCampaignVisualParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		visualById: {} as Dict<CampaignVisual>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.visualById[id]),
		byId: (state) => (id: number): CampaignVisual | null => state.visualById[id] ?? null,
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_VISUALS (state, visuals: CampaignVisual[]) {
			state.visualById = { ...state.visualById, ...createDict(visuals, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...visuals.map(v => v.id) ]));
		},
		SET_VISUALS (state, visuals: CampaignVisual[]) {
			state.visualById = { ...state.visualById, ...createDict(visuals, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetCampaignVisualParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/campaign-visual', { params });

			commit('APPEND_VISUALS', data.payload);
		},
		async prefetchVisuals ({ commit }, visualIds: number[]) {
			const responses = await Promise.all(visualIds.map(id => api.get(`/campaign-visual/${ id }`)));
			commit('SET_VISUALS', responses.map(resp => resp.data.payload));
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});



